import React from 'react';
import PropTypes from 'prop-types';
import { Panel, Loader, FlexGrid } from '@gasbuddy/react-components';
import ReactTooltip from 'react-tooltip';

import styles from './styles.css';

export default function StatCard({ title, subtitle, imageName, value, isLoading, ...rest }) {
  const [hasNoValue, setHasNoValue] = React.useState(false);

  React.useEffect(() => {
    setHasNoValue(value === 'N/A');
  }, [value]);

  const formatStatValue = () => {
    if (typeof value !== 'number') {
      return value;
    }
    if (value >= 1000 && value < 100000) {
      return Number(value).toLocaleString();
    }
    if (value >= 100000 && value < 1000000) {
      return `${(value / 1000).toFixed(2)}k`;
    }
    if (value >= 1000000) {
      return `${(value / 1000000).toFixed(2)}M`;
    }
    return value;
  };

  return (
    <FlexGrid.Column {...rest}>
      <div className={styles.statCardImageContainer}>
        <img className={styles.statCardImageOval} src="/images/app/oval-border.png" alt="stat-card-oval" />
        <img className={styles.statCardImageOval} src={`/images/app/${imageName}.png`} alt={`stat-card-${imageName}`} />
      </div>
      <Panel raised className={styles.statCardPanel}>
        <div>
          <div className={styles.statCardTitle}>{title}</div>
          <div className={styles.statCardSubtitle}>{subtitle}</div>
          <div className={styles.statCardContent}>
            <div className={`${styles.statCardValue} ${hasNoValue ? styles.noValue : ''}`}>
              {isLoading && <Loader size="sm" style={{ fontSize: '18px' }} /> }
              {!isLoading && (
                hasNoValue
                  ? (
                    <>
                      <span data-tip data-for={`stat-card-${imageName}`}>{value}</span>
                      <ReactTooltip id={`stat-card-${imageName}`} place="top" effect="solid">
                       The station(s) currently does not qualify for a score
                      </ReactTooltip>
                    </>
                  ) : (
                    <>
                      <div data-tip data-for={`stat-card-${imageName}-value`}>{formatStatValue()}</div>
                      <ReactTooltip id={`stat-card-${imageName}-value`} place="bottom" effect="solid">
                        {/* if we pass '0' as the child for ReactTooltip it displays "true" instead of "0" in the toolip */}
                        {value === 0 ? '0' : null}
                        {typeof value === 'number' && value !== 0 ? Number(value) : null}
                        {typeof value !== 'number' ? value : null}
                      </ReactTooltip>
                    </>
                  )
              )}
            </div>
          </div>
        </div>
      </Panel>
    </FlexGrid.Column>

  );
}

StatCard.propTypes = {
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  imageName: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isLoading: PropTypes.bool,
};

StatCard.defaultProps = {
  isLoading: true,
};
